import { t } from '@/utils/i18n'
import { OptionItem } from '@/types/interfaces'
import dayjs from 'dayjs'

export const dateSelectTags: OptionItem[] = [
  {
    label: t('今天'),
    value: 'today',
  },
  {
    label: t('本月'),
    value: 'thisMonth',
  },
  {
    label: t('本季'),
    value: 'thisQuarter',
  },
  {
    label: t('本年'),
    value: 'thisYear',
  },
]

export const defaultDateTag = dateSelectTags.find(
  (tag) => tag.value === 'thisMonth'
)

// 默认日期的最小值和最大值，十年前和十年后
export const DEFAULT_MIN_DATE = dayjs().subtract(10, 'year').toDate()
export const DEFAULT_MAX_DATE = dayjs().add(10, 'year').toDate()
